let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("exiT6")).then(() => parcelRequire('llE8x'));